import { useEffect, useState } from "react";

export const isPLOnboardingActive = () =>
  Boolean(document.querySelector(".onboarding__wrapper.is-active"));

const useIsPLOnboardingOpen = () => {
  const [isOpen, setIsOpen] = useState(isPLOnboardingActive);

  useEffect(() => {
    const updateIsOpen = () => setIsOpen(isPLOnboardingActive());

    updateIsOpen();

    // PL can unmount the wrapper (still marked is-active) as well as toggle its class
    const observer = new MutationObserver(updateIsOpen);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, []);

  return isOpen;
};

export default useIsPLOnboardingOpen;
